import React from "react";
import { ImageGallery } from "./ImageGallery";
import { buildImageURLs } from "./api/imageService";

interface ColorWheelProps {
  rows?: number;
}

export const ColorWheel: React.FC<ColorWheelProps> = ({ rows = 3 }) => {
  const folders = [
    "white",
    "brown",
    "green",
    "yellow",
    "orange",
    "red",
    "pink",
    "purple",
    "blue",
  ];

  const images: string[][] = folders.map((folder) =>
    buildImageURLs(folder, 15)
  );

  return <ImageGallery images={images} rows={rows} />;
};
